import React, { useState, Fragment, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { ReferenciaCabecera } from "../../../interfaces/ReferenciaCabecera";
import { normalizeTwoWords, formatImageAlt } from "../../../shared/utils/stringUtilities";
import Button from "../../atoms/button/button";
import Breadcrumb from "../../atoms/breadcrumb/breadcrumb";

import "./headboardService.scss";

const HeadboardService = (props: ReferenciaCabecera) => {
  const [sliderIndex, setSliderIndex] = useState(0);
  const [slider, setSlider] = useState<any>();
  const [infoArray, setInfoArray] = useState<any>([]);

  useEffect(() => {
    setInfoArray(Object.values(props));
  }, []);

  const getCurrentPage = () => {
    const arr = props[0].migaDePan.split("/");
    return arr[arr.length - 1].trim();
  };

  const goToNext = () => {
    slider.slickGoTo(sliderIndex + 1);
  };

  const goToBack = () => {
    slider.slickGoTo(sliderIndex - 1);
  };

  const isActiveBack = (_true: any, _false: any) =>
    sliderIndex > 0 ? _true : _false;

  const isActiveNext = (_true: any, _false: any) =>
    sliderIndex < infoArray.length - 1 ? _true : _false;

  const settings = {
    arrows: false,
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (_: number, next: number) => setSliderIndex(next),
  };

  return (
    <section className="o-headboard-service">
      <Breadcrumb content={`${props[0].migaDePan}`} />
      <Slider
        ref={(_slider) => setSlider(_slider)}
        {...settings}
        className="o-headboard-service__carrousel"
      >
        {infoArray.map((value, index) => (
          <Fragment key={index}>
            <article className="o-headboard-service__carrousel__content">
              <div>
                <div className="bg-black" />
                <img
                  className="o-headboard-service__carrousel__content__image"
                  src={value.imagenHeader.file.url}
                  alt={formatImageAlt(value.imagenHeader.title) || "Imagen cabecera"}
                />
              </div>
              <div className="o-headboard-service__carrousel__content__texts">
                <p className="o-headboard-service__carrousel__book-name">
                  <span>{value.tituloPrincipal}</span>
                </p>
                <p className="o-headboard-service__carrousel__book-description hide-on-mobile">
                  {value.descripcion.json.content[0].content[0].value}
                </p>
                <div className="o-headboard-service__carrousel__cta">
                  <Button
                    id={"buttonContentRotator-" + index}
                    type="link"
                    href={value.redireccionBoton}
                    classname={"secondary"}
                    text={"CONOCER MÁS"}
                    isDisabled={false}
                    gtmMark={`gtm${normalizeTwoWords(
                      getCurrentPage()
                    )}Banner${normalizeTwoWords(value.tituloPrincipal)}`}
                  />
                </div>
              </div>
            </article>
          </Fragment>
        ))}
      </Slider>

      <div
        className="arrow-content arrow-content__left hide-on-mobile"
        onClick={isActiveBack(goToBack, undefined)}
      >
        <div className="arrows">
          <div className="arrows-contain">
            <div
              className={isActiveBack(
                "arrow icon-chevron-left active",
                "arrow icon-chevron-left"
              )}
            />
          </div>
        </div>
      </div>

      <div
        className="arrow-content arrow-content__right hide-on-mobile"
        onClick={isActiveNext(goToNext, undefined)}
      >
        <div className="arrows">
          <div className="arrows-contain">
            <div
              className={isActiveNext(
                "arrow icon-chevron-right active",
                "arrow icon-chevron-right"
              )}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeadboardService;
